import { ClbInputText, ClbModal } from '@celebration/react';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import {
    getSelectOptionsEnumLoadSuspensionReason,
    suspensionReasonMap,
} from '../../../../utils/loads-utils';
import LoadSuspensionReason from '../../../../enums/load-suspension-reason.enum';
import ILoadCardSuspensionModalProps from '../../interfaces/ILoadCardSuspensionModalProps';
import SelectAutocomplete from '../../../../../../../common/components/select-autocomplete';

function LoadCardSuspensionModal({
    onSubmit,
    onCancel,
    onChangeReason,
}: Readonly<ILoadCardSuspensionModalProps>) {
    const { t } = useTranslation();

    const [reason, setReason] = useState<string>('');

    const [isShowingOtherReasonInput, setIsShowingOtherReasonInput] =
        useState<boolean>(false);

    const getSuspensionReasonOptions = () => {
        let reasons = getSelectOptionsEnumLoadSuspensionReason();
        reasons.forEach(x => {
            x.label = t(x.label);
            return x;
        });

        reasons = [{ value: '', label: t('Selecionar') }, ...reasons];

        return reasons;
    };

    const isReasonEmpty = (): boolean => {
        return reason === '' || reason === null || reason === undefined;
    };

    const changeSuspensionReason = useCallback(
        (event: any) => {
            const loadSuspensionReason =
                LoadSuspensionReason[
                    event as keyof typeof LoadSuspensionReason
                ];

            if (loadSuspensionReason === LoadSuspensionReason.Outro) {
                setIsShowingOtherReasonInput(true);
                setReason('');
                onChangeReason('');
            } else {
                setIsShowingOtherReasonInput(false);
                setReason(t(suspensionReasonMap[loadSuspensionReason]));
                onChangeReason(t(suspensionReasonMap[loadSuspensionReason]));
            }
        },
        [onChangeReason, t],
    );

    return (
        <div data-testid="card-loads-suspension-modal">
            <ClbModal
                key="card-loads-suspension-modal"
                title={t('LoadConfirmacaoSuspensaoTitulo')}
                description={t('LoadConfirmacaoSuspensaoMensagem')}
                open
                onClose={onCancel}
                itemsFooter={[
                    {
                        id: 'suspend-load-confirmation-modal-yes-button',
                        key: `suspend-load-confirmation-modal-yes-button`,
                        'data-testid':
                            'suspend-load-confirmation-modal-yes-button',
                        type: 'button',
                        styleType: 'danger',
                        role: 'button',
                        label: t('Suspender'),
                        title: t('UsuarioConfirmacaoAcaoSuspensao'),
                        icon: 'spam',
                        disabled: isReasonEmpty(),
                        loading: false,
                        onClick: onSubmit,
                    },
                    {
                        id: 'suspend-load-confirmation-modal-no-button',
                        key: `suspend-load-confirmation-modal-no-button`,
                        'data-testid':
                            'suspend-load-confirmation-modal-no-button',
                        type: 'button',
                        styleType: 'secondary',
                        role: 'button',
                        label: t('Cancelar'),
                        title: t('UsuarioCancelaAcaoSuspensao'),
                        disabled: false,
                        loading: false,
                        onClick: onCancel,
                    },
                ]}
            >
                <div className="cards-load-suspension-modal__suspension-reason">
                    <SelectAutocomplete
                        showSearch
                        id="load-suspension-reason"
                        key="load-suspension-reason"
                        label={t('LoadConfirmacaoSuspensaoMotivo')}
                        onChange={changeSuspensionReason}
                        placeholder={t('Selecionar')}
                        options={getSuspensionReasonOptions()}
                        data-testid="load-suspension-reason"
                        getPopupContainer={x => x.parentNode}
                        error={isReasonEmpty()}
                        aria-required
                    />
                </div>
                <div className="cards-load-suspension-modal__suspension-reason">
                    <ClbInputText
                        id="load-supension-another-reason"
                        key="load-supension-another-reason"
                        data-testid="load-supension-another-reason"
                        placeholder={t('Inserir')}
                        label={t('LoadConfirmacaoSuspensaoOutroMotivo')}
                        value={reason}
                        size="lg"
                        maxLength={45}
                        required
                        disabled={!isShowingOtherReasonInput}
                        helperText={t('CampoObrigatorio')}
                        showHelperText={
                            isShowingOtherReasonInput && isReasonEmpty()
                        }
                        error={isShowingOtherReasonInput && isReasonEmpty()}
                        onChange={(event: any) => {
                            setReason(event.target.value);
                            onChangeReason(event.target.value);
                        }}
                    />
                </div>
            </ClbModal>
        </div>
    );
}

export default LoadCardSuspensionModal;
